import { Injectable } from '@angular/core';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';

@Injectable()
export class AzureDownloadService {
  private chunkSize = 1024 * 1024; // 1MB chunks

  constructor(private appLoaderService: AppLoaderService) {  }

  getFileSize(url: string) {
    return new Promise<number>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('HEAD', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(parseInt(xhr.getResponseHeader('Content-Length') || '0', 10));
          } else {
            reject('Error fetching file size');
          }
        }
      };
      xhr.onerror = () => reject('Error fetching file size');
      xhr.send();
    });
  }

  downloadFile(url: string, progressCallback: (percentage: number) => void) {
    const self = this;

    this.getFileSize(url).then(function (fileSize) {
      let chunks = [];
      let downloadedSize = 0;
      let numChunks = Math.ceil(fileSize / self.chunkSize);
      let chunkPromises = [];

      for (let i = 0; i < numChunks; i++) {
        (function (index) {
          let start = index * self.chunkSize;
          let end = Math.min(start + self.chunkSize - 1, fileSize - 1);

          let promise = new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.setRequestHeader('Range', `bytes=${start}-${end}`);
            xhr.responseType = 'arraybuffer';

            xhr.onload = function () {
              if (xhr.status === 206 || xhr.status === 200) {
                downloadedSize += xhr.response.byteLength;
                progressCallback((downloadedSize / fileSize) * 100);
                resolve(xhr.response);
              } else {
                reject(`Error downloading chunk ${index}`);
              }
            };

            xhr.onerror = function () {
              reject(`Network error in chunk ${index}`);
            };

            xhr.send();
          });

          chunkPromises.push(promise);
        })(i);
      }

      Promise.all(chunkPromises).then(function (data) {
        let combined = new Blob(data, { type: 'application/zip' });
        let link = document.createElement('a');
        link.href = URL.createObjectURL(combined);
        link.download = 'SCAL360.zip';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (error) {
        console.error('Download failed:', error);
      });
    }).catch(function (error) {
      console.error('Failed to fetch file size:', error);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/extra-pages/DownloadSCAL360/AzureDownloadService.service.ts